import React, { useState } from "react";
import classNames from "classnames";
import "./Tabs.css";

const Tabs = ({ tabs, selected = 0, onChange }) => {
  const handleChange = (index) => {
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <ul className="tabs">
      {tabs.map((elem, index) => (
        <li
          key={index}
          className={classNames("tabs-item", selected === index && "selected")}
          onClick={() => handleChange(index)}
        >
          {elem.title}
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
